'use client';

import { FC } from 'react';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useRouter } from 'modules/next/hooks';
import { AppRoutes } from 'modules/shop/routes';
import { ActionButton } from './ActionButton';
import styles from './styles.module.css';

export const BackHomeButton: FC = () => {
  const router = useRouter();
  const t = useTranslations();

  return (
    <ActionButton
      text={t('common.buttons.home-page')}
      icon="arrowRight"
      action={() => router.push(AppRoutes.HOME)}
    />
  );
};

export const BackHomeCartButton: FC = () => {
  const router = useRouter();
  const t = useTranslations();

  return (
    <ActionButton
      text={t('common.buttons.cart-home-page')}
      icon="arrowRight"
      action={() => router.push(AppRoutes.HOME)}
      classes={{
        root: styles.cartBackButton,
      }}
      data-testId="cartBackButton"
    />
  );
};
